<template>
<div class="site-header yo-fixed-top" style="padding:0 10px;">
   <!--mobile -->
   
   <div class="row yo-text-n" v-if="$teras.app.device!='desktop'">
      <div class="col s10">&#160;</div>
      <div class="col s2"><a class="button" v-on:click="$teras.event.emit('sidebarToggle')" ><i class="material-icons">menu</i></a></div>
      <!-- <div style="background:red;width:10px;height:40px;"></div> -->
   </div>


  <!-- desktop -->
   <div class="row yo-text-m" v-if="$teras.app.device=='desktop'">
      <div class="col s9 yo-align-left">Società Italiana di Malattie Genetiche Pediatriche e Disabilità</div>
      <div class="col s3">
         <div class="row yo-text-n" v-if="$teras.check.auth">
            <div class="col s4 yo-align-rigth yo-valign-text-center" style="height:52px;"><router-link to="/home">HOME</router-link></div>
            <!-- <div class="col s4 yo-align-right yo-valign-text-center" style="height:52px;"><a href="https://www.sip.it" target="blank">WWW.SIP.IT</a></div> -->
            <div class="col s4 yo-align-rigth yo-valign-text-center" style="height:52px;"><a @click.prevent="$teras.event.emit('logout')" href="#!" >ESCI</a></div>
         </div>
      </div>
   </div>

   
</div>
</template>

<script>
export default {
  name: 'site-header',
  components: {
     
  }
}
</script>
<style>
#app.device-tablet .site-header{
   
}
.site-header{
   height:52px;
   overflow:hidden;
   background: #004680;
   border-bottom:1px solid grey;
   color:#ffffff;
}.site-header > .row > div{
   line-height:52px;    
}.site-header a{
   color:#ffffff;
   display:block;
   text-align:center;
}.site-header a:first{
   border-left:none !important;
}.site-header a.button i, .footer-bottom a.button i{
    line-height: 40px;
    height: 40px;
    font-size: 3.2rem;
    color:#fff;
}
</style>
